import { jsPDF } from 'jspdf';
import UtilsBufer from '../Tools/UtilsBufer';
import DateConverter from '../Tools/DateConverter';
import cabecera from '../../assets/cabecerMedica.jpeg';
import kingdomlogo from '../../assets/logo_kingdom_256px.png'
import kingtorlogo from '../../assets/logokingtor.jpg'

function getXcentroTexto(valpagi, valtext) {
    return (valpagi - valtext) / 2
}
function obtenerEdad(fecha) {
    var fechaNacimiento = new Date(fecha);
    var fechaActual = new Date()
    const diferenciaAnios = fechaActual.getFullYear() - fechaNacimiento.getFullYear();
    const diferenciaMeses = fechaActual.getMonth() - fechaNacimiento.getMonth();
    const diferenciaDias = fechaActual.getDate() - fechaNacimiento.getDate();

    // Si el mes o día de fecha2 es menor, resta un año
    return diferenciaMeses < 0 || (diferenciaMeses === 0 && diferenciaDias < 0)
        ? diferenciaAnios - 1
        : diferenciaAnios;
}
async function generarFormRespondido(datos, usuario,regional) {
    try {
        var x = 10, y = 10;
        const pdf = new jsPDF('p', "mm");
        var numPagina = 1;
        var encabezado = "Departamento de seguridad "
        pdf.addImage(cabecera, "JPEG", 10, 5, 35, 15);
        if(regional=='990'){
            pdf.addImage(kingdomlogo,'PNG',pdf.internal.pageSize.getWidth()-30,5,13,10)
        }else{
            pdf.addImage(kingtorlogo,'JPEG',pdf.internal.pageSize.getWidth()-40,5,35,13)
        }
        pdf.text(encabezado.toUpperCase(), getXcentroTexto(pdf.internal.pageSize.getWidth(), pdf.getTextWidth(encabezado)), y);
        encabezado = "y salud ocupacional";
        pdf.text(encabezado.toUpperCase(), getXcentroTexto(pdf.internal.pageSize.getWidth(), pdf.getTextWidth(encabezado)), y + 6);
        pdf.line(10, y + 8, pdf.internal.pageSize.getWidth() - 10, y + 8);
        y += 20
        pdf.setFont('Arial', null);
        pdf.setFontSize(14);
        pdf.text(datos.ENCUESTA.TITULO.toUpperCase(), getXcentroTexto(pdf.internal.pageSize.getWidth(), pdf.getTextWidth(datos.ENCUESTA.TITULO)), y)
        pdf.setFont('Arial', null);
        pdf.setFontSize(12);
        y += 6
        pdf.text(`NOMBRE Y APELLIDO: ${usuario.NOMBRE_COMPLETO}`, x, y);
        y += 6
        pdf.text(`FECHA DE INICIO: ${DateConverter.formatoFechaNumeric(usuario.EMPRESA_FECHA_INGRESO)}`, x, y);
        y += 6
        pdf.text(`EDAD: ${obtenerEdad(usuario.CARNET_NACIMIENTO)}       SEXO: (${usuario.CARNET_SEXO})      ESTADO CIVIL: ${usuario.ESTADO_CIVIL}`, x, y);
        y += 6
        pdf.text(`FECHA NACIMIENTO: ${DateConverter.formatoFechaNumeric(usuario.CARNET_NACIMIENTO)}`,x,y);
        y += 6
        pdf.text(`EMPRESA: ${usuario.AUX.EMPRESA}     SUCURSAL: ${usuario.AUX.SUCURSAL}`,x,y)
        y += 6
        pdf.text(`AREA: ${usuario.AUX.CARGO}`,x,y)
        y += 6
        console.log('dibujando las preguntas')
        var anchoTexto=pdf.internal.pageSize.getWidth()-20;
        for(var pregunta of datos.PREGUNTAS){
            var respuestaFiltrada = datos.RESPUESTA.filter(item=>item.ID_PREGUNTA==pregunta.ID_PREGUNTA)
            if(['R','F','H'].includes(pregunta.TIPO)==true){
                pdf.setFont('arial','bold');
                pdf.text(UtilsBufer.getText(pregunta.DESCRIPCION).toUpperCase()+' :',x,y)
                y+=8
                pdf.setFont('arial','');
                pdf.text(UtilsBufer.getText(respuestaFiltrada[0].DESCRIPCION),x,y,{ maxWidth: anchoTexto, align: "justify" })
                var lineas = pdf.splitTextToSize(UtilsBufer.getText(respuestaFiltrada[0].DESCRIPCION), anchoTexto);
                y+=lineas.length*6
            }else if(pregunta.TIPO=='S'){
                respuestaFiltrada = respuestaFiltrada.filter((item)=>item.ID_OPCION!=0)
                console.log(respuestaFiltrada);
                pdf.setFont('arial','bold');
                var pregun = UtilsBufer.getText(pregunta.DESCRIPCION)+': '
                pdf.text(pregun.toUpperCase(),x,y)
                pdf.setFont('arial','');
                pdf.text(UtilsBufer.getText(respuestaFiltrada[0].NOMBRE_OPCION),x+(pregun.length*3),y)
                y+=8
            }else if(pregunta.TIPO=='O'){
                respuestaFiltrada = respuestaFiltrada.filter((item)=>item.ID_OPCION!=0)
                pdf.setFont('arial','bold');
                pdf.text(UtilsBufer.getText(pregunta.DESCRIPCION).toUpperCase(),x,y)
                y+=8
                pdf.setFont('arial','');
                for(var opcion of respuestaFiltrada){
                    var optionDescripcion = UtilsBufer.getText(opcion.NOMBRE_OPCION).toUpperCase()+': '
                    optionDescripcion += UtilsBufer.getText(opcion.DESCRIPCION)
                    pdf.text(optionDescripcion,x,y,{ maxWidth: anchoTexto, align: "justify" })
                    var lineas = pdf.splitTextToSize(optionDescripcion, anchoTexto);
                    y+=lineas.length*7   
                }
            }else if(pregunta.TIPO=='M'){
                respuestaFiltrada = respuestaFiltrada.filter(item=>item.ID_OPCION!=0)
                pdf.setFont('arial','bold');
                pdf.text(UtilsBufer.getText(pregunta.DESCRIPCION).toUpperCase()+': ',x,y)
                y+=8
                pdf.setFont('arial','');
                var opciones = ''
                for(var opcion of respuestaFiltrada){
                    opciones += UtilsBufer.getText(opcion.NOMBRE_OPCION).toUpperCase()+'  ;  '
                }
                pdf.text(opciones,x,y,{ maxWidth: anchoTexto, align: "justify" })
                var lineas = pdf.splitTextToSize(opciones, anchoTexto);
                y+=lineas.length*7 
            }
            if(y>=pdf.internal.pageSize.getHeight()-30){
                pdf.addPage()
                numPagina+=1
                pdf.setPage(numPagina)
                y=10;x=10;
                encabezado = "Departamento de seguridad "
                pdf.addImage(cabecera, "JPEG", 10, 5, 35, 15);
                if(regional=='990'){
                    pdf.addImage(kingdomlogo,'PNG',pdf.internal.pageSize.getWidth()-30,5,13,10)
                }else{
                    pdf.addImage(kingtorlogo,'JPEG',pdf.internal.pageSize.getWidth()-40,5,35,13)
                }
                pdf.text(encabezado.toUpperCase(), getXcentroTexto(pdf.internal.pageSize.getWidth(), pdf.getTextWidth(encabezado)), y);
                encabezado = "y salud ocupacional";
                pdf.text(encabezado.toUpperCase(), getXcentroTexto(pdf.internal.pageSize.getWidth(), pdf.getTextWidth(encabezado)), y + 6);
                pdf.line(10, y + 8, pdf.internal.pageSize.getWidth() - 10, y + 8);
                y += 20
                pdf.setFont('Arial', null);
                pdf.setFontSize(14);
            }
        }
        pdf.setFont('arial','bold');
        pdf.line(40, pdf.internal.pageSize.getHeight()-20, 70, pdf.internal.pageSize.getHeight()-20);
        pdf.text('MEDICO',45,pdf.internal.pageSize.getHeight()-15)
        pdf.line(140, pdf.internal.pageSize.getHeight()-20, 180, pdf.internal.pageSize.getHeight()-20);
        pdf.text('COLABORADOR',145,pdf.internal.pageSize.getHeight()-15)
        var fechaRespuesta = datos.RESPUESTA[0].FECHA
        var piePagina = `${regional=='990'?'Cochabamba':'Santa Cruz'} - ${DateConverter.formatoFecha(fechaRespuesta)}`
        pdf.text(piePagina,getXcentroTexto(pdf.internal.pageSize.getWidth(), pdf.getTextWidth(piePagina)),pdf.internal.pageSize.getHeight()-9)
        var fecha = new Date().toISOString()
        pdf.save(`pdfRespuestaFormulario${fecha}.pdf`);
        return { "ok": `pdfRespuestaFormulario${fecha}.pdf` }
    } catch (error) {
        console.log(error)
        return { "error": error.message }
    }
}

export default {
    generarFormRespondido
}